<ul>
    @for (entry of displayedAlternatives(); track entry.alternative.robot.id) {
        <li class="robot-alternatives-item">
            <robot-selector-cobot-card [robot]="entry.alternative.robot" [viewProductLabel]="viewProductLabel()" />

            @if (entry.statusLine) {
                <p class="robot-alternatives-status sir-text-style-paragraph-s-default">{{ entry.statusLine }}</p>
            }

            <button
                siriusButton
                class="robot-alternatives-action"
                buttonType="secondary"
                size="medium"
                type="button"
                (click)="alternativeSelected.emit(entry.alternative.robot)">
                {{ entry.relaxRequirementLabel }}
            </button>
        </li>
    }
</ul>
